var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTrustWallet = function SvgTrustWallet(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2702 1.00122H9.72977C4.90845 1.00122 1 4.90967 1 9.73099V18.2714C1 23.0928 4.90845 27.0012 9.72977 27.0012H18.2702C23.0915 27.0012 27 23.0928 27 18.2714V9.73099C27 4.90967 23.0915 1.00122 18.2702 1.00122Z",
    fill: "white",
    stroke: "#DFE5EC",
    strokeWidth: 0.309061
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0806 6.96826C16.5185 9.0044 19.3143 8.87882 20.113 8.87882C19.9384 20.4582 18.6069 18.162 14.0806 21.4089C9.55431 18.162 8.23135 20.4582 8.05664 8.87882C8.84707 8.87882 11.6427 9.0044 14.0806 6.96826Z",
    stroke: "#3375BB",
    strokeWidth: 1.87385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTrustWallet);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/trust-wallet.0e5604628d678aea7085c3a99c95662f.svg";